export class BillSubmissionMethod {
	public id: number;
	public name: string;
	public sortOrder: number;

	constructor(billSubmissionMethod?: Subset<BillSubmissionMethod>) {
		Object.assign(this, billSubmissionMethod);
	}
}
